
class Auth {

  constructor(){
    this.authenticated = false
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
      return null;
  }

  login(cb){
    this.authenticated = true;
    if(cb){ cb(); }
  }

  logout(cb){
    if (this.authenticated){
      alert('Acaba de cerrar sesion');
      this.authenticated = false;
      cb()
    }
  }

  isAuthenticated(){
    return this.authenticated;
  }

  isRRHHGranted(cb){
    let _auth = this.getCookie("asa_hd_auth");
    
    // REACT_APP_API_VAL_TOKEN no existe en el .env (la variable se llama
    // REACT_APP_API_VALIDATE_TOKEN): la URL quedaba con "undefined" al final.
    fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_VALIDATE_TOKEN,
      {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          token : _auth
        })
      })
      .then((res) => res.json())
      .then((json) => {

        const rrhh = ((json.grants || []).indexOf("rrhh") > -1) || ((json.grants || []).indexOf("super") > -1);
        
        cb(null, rrhh);
      }).catch(err => cb(err));
  }
}

export default new Auth();